import { useEffect, useState, RefObject } from 'react'

export function useInView(ref: RefObject<Element | null>, options: IntersectionObserverInit = {}) {
    const [isInView, setIsInView] = useState(false)

    useEffect(() => {
        if (!ref.current) return

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsInView(true)
                observer.disconnect() // Trigger once
            }
        }, options)

        observer.observe(ref.current)

        return () => {
            observer.disconnect()
        }
    }, [ref, options])

    return isInView
}
